import { lazy, Suspense } from 'react';

const PdpSharedShippingBadgeLazyComponent = lazy(
    () => import(/* webpackChunkName: "PdpSharedShippingBadge" */ './PdpSharedShippingBadge.tsx')
);

export const PdpSharedShippingBadgeLazy = props => (
    <Suspense fallback="">
        <PdpSharedShippingBadgeLazyComponent {...props} />
    </Suspense>
);
